/**
 * Store data
 * @param {*} key 
 * @param {*} data 
 */
export function store(key,data){
    localStorage.setItem(key, JSON.stringify(data));
};

/**
 * Get data from local storage
 * @param {*} key 
 */
export function get(key){
    let data = localStorage.getItem(key);
    return JSON.parse(data);
};

/**
 * Remove data from local storage
 * @param {*} key 
 */
export async function remove(key) {
    await localStorage.removeItem(key);
    return true;
}
